import React, { ReactNode } from "react"
import IconV2 from "../icon-v2"
import { StyledItem, StyledItemHeader, StyledItemContent } from "./partials"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
export interface ItemProps {
  title: string
  description: string
  default_open: boolean
  microdata: boolean
}

class ItemCmp extends React.Component<ItemProps> { 
  state = {
    is_open: true,
  }
  toggle = () => {
    this.setState({
      is_open: !this.state.is_open,
    })
  }
  componentDidMount = () => {
    this.setState({
      is_open: this.props.default_open,
    })
  }
  render() {
    return (
      <StyledItem default_open={this.props.default_open}>
        <StyledItemHeader is_open={this.state.is_open} onClick={this.toggle}>
          <p itemProp={this.props.microdata ? "name" : undefined}>{this.props.title}</p>
          <div>
            <IconV2 icon="chevron-down" />
          </div>
        </StyledItemHeader>
        {this.props.description && (
          <StyledItemContent
            is_open={this.state.is_open}
          >
            <div
              itemScope
              itemProp={this.props.microdata ? "acceptedAnswer" : undefined}
              itemType={this.props.microdata ? "https://schema.org/Answer" : undefined}
            >
              <div itemProp={this.props.microdata ? "text" : undefined} ref={(element) => (this.contentRef = element)}>
              {
                                unified()
                                    .use(remarkParse)
                                    .use(remarkRehype)
                                    .use(rehypeReact as any, {
                                        createElement: React.createElement,
                                        components: remarkReactComponents,
                                        Fragment: React.Fragment
                                    })
                                    .processSync(this.props.description).result as ReactNode
                            }
              </div>
            </div>
          </StyledItemContent>
        )}
      </StyledItem>
    )
  }
}

export default ItemCmp
